export const environment = {
  production: true,
  graphqlURL: 'https://talent-hub-prod-server-6uadh2aniq-oa.a.run.app/graphql',
  aiServer: 'https://talent-hub-flask-server-prod-6uadh2aniq-oa.a.run.app/api',
};
